


















import { Component, Vue, Prop, Inject } from 'vue-property-decorator'
import { Toast } from 'vant'
import { queryCouponStatus, receivePlayCoupon, receiveBigServiceCoupon, getCoupon } from '../../home-service'
import { isLogin, toLogin } from '@utils/index'

@Component
export default class CouponItem extends Vue {
  @Prop({ default: () => [] }) readonly couponitem!: any
  // @Prop({ default: 0 }) readonly index!: number
  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_use_coupon')
  clickid_use_coupon!: string
  @Inject('clickid_recieve_coupon')
  clickid_recieve_coupon!: string

  hasGet = false

  login = isLogin()

  created() {
    this.hasGet = this.couponitem.status == 1
  }

  async receive(cid: string) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_recieve_coupon, positionParam: { citycode: this.pageTrackParams.pageParam.citycode, name: this.couponitem.name, couponcode: this.couponitem.id } })
    if (!this.login) {
      return toLogin()
    }
    try {
      if (this.couponitem.type == 2) {
        // 大服务优惠券
        const res = await receiveBigServiceCoupon(cid)
        if (res.code == 1) {
          return (this.hasGet = true)
        }
        Toast(res.msg)
      } else {
        const res = await receivePlayCoupon(cid)
        if (res.code === 1001) {
          return (this.hasGet = true)
        }
        Toast(res.message)
      }
    } catch (e) {
      console.log(e)
    }
  }

  async queryStatus() {
    try {
      const participatedRes = await queryCouponStatus(this.couponitem?.id)
      const { ret } = participatedRes?.data
      if (participatedRes.code === 1001 && ret) {
        const chanceRes = await getCoupon(this.couponitem?.id)
        if (chanceRes.code === 1001) {
          const { limit_day_all: limitDayAll, day, limit_total_all: limitTotalAll, total } = chanceRes?.data
          if ((limitDayAll && day === 0) || (limitTotalAll && total === 0)) {
            this.hasGet = true
          }
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  use() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_use_coupon, positionParam: { citycode: this.pageTrackParams.pageParam.citycode, name: this.couponitem.name, couponcode: this.couponitem.id } })
    location.href = 'https://w.cekid.com/public-ticket/coupon/service?naviType=4'
  }
}
